import { Controller } from "@hotwired/stimulus"
import flatpickr from "https://esm.sh/flatpickr@4.6.13?standalone"
import { Romanian } from "https://esm.sh/flatpickr@4.6.13/dist/l10n/ro.js"

export default class extends Controller {
  static targets = [ "details" ]
  static values  = {
    type: String, disable: Array,
    mode: { type: String, default: "single" },
    altInputClass: { type: String, default: "form-control input" },
    showMonths: { type: Number, default: 1 },
    dateFormat: { type: String, default: "F d, Y" },
    dateTimeFormat: { type: String, default: "F d, Y H:i" }
  }

  connect() {
    if (this.typeValue == "time") {
      this.flatpickr = flatpickr(this.element, this.#timeOptions)
    } else if (this.typeValue == "datetime") {
      this.flatpickr = flatpickr(this.element, this.#dateTimeOptions)
    } else {
      this.flatpickr = flatpickr(this.element, this.#basicOptions)
    }
  }

  disconnect() {
    this.flatpickr.destroy()
  }

  get #locale() {
    return Romanian || flatpickr.l10ns.default
  }

  get #timeOptions() {
    return { dateFormat: "H:i", enableTime: true, noCalendar: true, locale: this.#locale }
  }

  get #dateTimeOptions() {
    return { ...this.#baseOptions, altFormat: this.dateTimeFormatValue, dateFormat: "Y-m-d H:i", enableTime: true, locale: this.#locale }
  }

  get #basicOptions() {
    const altFormat = this.element.dataset.dateFormatValue || this.dateFormatValue
    return {
      ...this.#baseOptions,
      altFormat: altFormat,
      dateFormat: "Y-m-d",
      locale: this.#locale
    }
  }

  get #baseOptions() {
    return { altInput: true, altInputClass: this.altInputClassValue, disable: this.disableValue, mode: this.modeValue, showMonths: this.showMonthsValue, locale: this.#locale }
  }
}
